// Shared spherical-earth math for the web JS. One haversine definition so a
// precision change lands everywhere at once (Ruby's counterpart is GeoMath;
// the native app carries its own in its vertex helpers).
export const EARTH_RADIUS_M = 6371000

export function haversineMeters(lat1, lon1, lat2, lon2) {
  const rad = Math.PI / 180
  const dlat = (lat2 - lat1) * rad
  const dlon = (lon2 - lon1) * rad
  const x = Math.sin(dlat / 2) ** 2 +
    Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.sin(dlon / 2) ** 2
  return EARTH_RADIUS_M * 2 * Math.atan2(Math.sqrt(x), Math.sqrt(1 - x))
}

export function metersBetweenLatLon(a, b) {
  if (!a || !b) return 0
  const [lat1, lon1] = readLatLon(a)
  const [lat2, lon2] = readLatLon(b)
  if ([lat1, lon1, lat2, lon2].some(v => v == null || !Number.isFinite(Number(v)))) return 0

  return haversineMeters(Number(lat1), Number(lon1), Number(lat2), Number(lon2))
}

function readLatLon(value) {
  if (Array.isArray(value)) return [Number(value[0]), Number(value[1])]
  return [Number(value.lat), Number(value.lng ?? value.lon)]
}
